let ChangePassword = (function () {
  let fn, keyData, interval;

  keyData = {
    certifyNumber: null,
    checkNewPassword: false,
    newPasswordConfirm: false,
  };

  fn = {
    callback() {
      setTimeout(function () {
        $('#newPassword').focus(); // 웹접근성을 위한 포커싱
      }, 500);

      // 비밀번호 입력
      $('#newPassword')
        .focus(fn.checkPassword)
        .blur(function () {
          clearInterval(interval);
          if ($(this).val() !== $('#newPasswordRe').val())
            $('#newPasswordRe').val('');
        });

      // 이메일, 비밀번호 확인
      $('#newPasswordRe')
        .focus(fn.checkConfirm)
        .blur(function () {
          clearInterval(interval);
        });
    },
    checkPassword(e) {
      let obj;
      interval = setInterval(function () {
        obj = LoginValidator.password($('#newPassword').val());
        keyData.checkNewPassword = obj.valid;
        if (obj.valid === true)
          $('#newPasswordRegMsg')
            .removeClass('error')
            .addClass('ok')
            .html('사용해도 좋은 비밀번호입니다.');
        else
          $('#newPasswordRegMsg')
            .removeClass('ok')
            .addClass('error')
            .html(obj.msg);
      }, 50);
    },
    checkConfirm(e) {
      let value, self;
      value = $('#newPassword').val();
      self = this;

      interval = setInterval(function () {
        if (value === '')
          $('#newPasswordReValidaterMsg').removeClass('error, ok').html('');
        else if (value === $(self).val())
          $('#newPasswordReValidaterMsg')
            .removeClass('error')
            .addClass('ok')
            .html('비밀번호 값이 일치합니다.');
        else
          $('#newPasswordReValidaterMsg')
            .removeClass('ok')
            .addClass('error')
            .html('비밀번호 값이 일치하지 않습니다.');

        keyData['newPasswordConfirm'] = value !== '' && value === $(self).val();
      }, 50);
    },
    submit() {
      let param,
        submitOkObj,
        isSuccess = false;

      const newPassword = $('#newPassword').val();
      submitOkObj = LoginValidator.password(newPassword);

      param = {
        certifyNumber: keyData.certifyNumber,
        password: RsaCommon.getEncPassword(newPassword),
      };

      if (submitOkObj.valid !== true) {
        Alert(submitOkObj.msg);
        return false;
      }

      if (!keyData.checkNewPassword) {
        Alert('비밀번호를 양식에 맞게 작성하세요.', function () {
          $('#newPassword').focus();
        });
        return false;
      }

      if (!keyData.newPasswordConfirm) {
        Alert('비밀번호 확인이 비밀번호와 같지 않습니다.', function () {
          $('#newPasswordRe').focus();
        });
        return false;
      }

      $.ajax({
        type: 'post',
        dataType: 'json',
        beforeSend: Common.loading.show(),
        url: '/app/applicant/updatePassword',
        async: false,
        data: param,
      })
        .always(Common.loading.countHide)
        .fail(Common.ajaxOnfail)
        .done(function (x, e) {
          if (x.message) Alert(x.message);
          else {
            isSuccess = true;
            Alert('비밀번호가 변경되었습니다.');
          }
        });

      return isSuccess;
    },
    template() {
      let t = [];

      t.push(
        '<div style="margin-bottom:10px;font-size:18px;text-align:center;"><strong>새로 사용할 비밀번호</strong>를 입력하세요.</div>',
      );
      t.push(
        '<div style="font-size:13px;">기존에 사용하시던 비밀번호는 암호화 되어 있어 확인이 불가능합니다.<br/>비밀번호를 새로 설정하세요.</div>',
      );
      t.push(
        '<div style="margin-top:15px;"><strong>8~9자 영문 대문자/소문자/특수문자/숫자 중 3종류, 혹은 10자 이상 영문/숫자/특수문자 중 2종류를 사용하세요.</strong></div>',
      );
      t.push('<div style="margin-top:30px;">');
      t.push(
        '	<div><input type="password" id="newPassword" class="text text100per" placeholder="새 비밀번호" title="새 비밀번호" data-valid="blank length-limit" data-min-limit="10" data-max-limit="16" /></div>',
      );
      t.push('	<div id="newPasswordRegMsg"></div>');
      t.push(
        '	<div style="margin-top:10px;"><input type="password" id="newPasswordRe" class="text text100per" placeholder="새 비밀번호 확인" title="새 비밀번호 확인" data-valid="blank length-limit" data-min-limit="10" data-max-limit="16" /></div>',
      );
      t.push('	<div id="newPasswordReValidaterMsg"></div>');
      t.push('</div>');

      return t.join('');
    },
  };

  return function (certifyNumber) {
    let modalOpt;

    if (!certifyNumber) throw new Error('인증번호를 입력하세요.');

    keyData.certifyNumber = certifyNumber;

    modalOpt = {
      title: '지원서 비밀번호 찾기',
      width: '600',
      height: '450',
      scroll: false,
      confirmMsg: '비밀번호를 변경하시겠습니까?',
      callback: fn.callback,
      btnTitle: '인증',
      btnEvent: fn.submit,
      content: fn.template(),
    };

    Common.modal(modalOpt);
  };
})();

// 비밀번호 찾기
let FindPassword = (function () {
  let fn, interval, keyData, param;

  keyData = {
    time: 300, // 5분
  };

  param = {
    jobnoticeSn: null,
    name: null,
    email: null,
    password: null,
  };

  fn = {
    init() {
      if (interval) clearInterval(interval);
      if (fn.validation()) fn.loadModal();
    },
    validation() {
      param.jobnoticeSn = $('#jobnoticeSn').val();
      param.name = $('#name').val();
      param.email = $('#email').val();

      if (!param.jobnoticeSn) {
        Alert('채용공고를 선택하세요.', function () {
          $('#jobnoticeSn').focus();
        });
        return false;
      }

      if (!param.name) {
        Alert('성명을 입력하세요.', function () {
          $('#name').focus();
        });
        return false;
      }

      if (!param.email) {
        Alert('이메일을 입력하세요.', function () {
          $('#email').focus();
        });
        return false;
      }

      return true;
    },
    loadModal() {
      let modalOpt,
        isSuccess = false;

      $.ajax({
        type: 'post',
        dataType: 'json',
        beforeSend: Common.loading.show(),
        url: '/app/applicant/loginForPasswordFind',
        async: false,
        data: $('#frm').serializeArray(),
      })
        .always(Common.loading.countHide)
        .fail(Common.ajaxOnfail)
        .done(function (x, e) {
          keyData.time = x.leftTime;
          if (x.message) Alert(x.message);
          else isSuccess = true;
        });

      modalOpt = {
        title: '지원서 비밀번호 찾기',
        width: '450',
        height: '300',
        scroll: false,
        enabledConfirm: false,
        callback: fn.callback,
        btnTitle: '인증',
        btnEvent: fn.submit,
        content: fn.template(),
      };

      if (isSuccess) Common.modal(modalOpt);
    },
    callback() {
      setTimeout(function () {
        $('#certify').focus(); // 웹접근성을 위한 포커싱
      }, 500);

      interval = setInterval(function () {
        // 5분 카운트
        if (keyData.time <= 0) {
          // 응답시간 초과시 경고창 출력 후 팝업 닫음
          $('button[data-button="modalClose"]').click();
          Alert('응답시간이 초과되었습니다.');
          clearInterval(interval);
        } else {
          $('#modalTimer').html(fn.leftTime(keyData.time));
          keyData.time = keyData.time - 1;
        }
      }, 1000);

      $('#modalTimer').html(fn.leftTime(keyData.time));
    },
    submit() {
      let isSuccess = false,
        param = {};

      param.certifyNumber = $('#certify').val();

      $.ajax({
        type: 'post',
        dataType: 'json',
        beforeSend: Common.loading.show(),
        url: '/app/applicant/certifyPasswordFind',
        async: false,
        data: param,
      })
        .always(Common.loading.countHide)
        .fail(Common.ajaxOnfail)
        .done(function (x, e) {
          if (x.message) Alert(x.message);
          else {
            isSuccess = true;
            setTimeout(function () {
              ChangePassword(param.certifyNumber);
            }, 1000);
          }
        });

      return isSuccess;
    },
    template() {
      let t = [];

      t.push(
        '<div style="font-size:14px;text-align:center;">해당 이메일로 인증번호를 발송했습니다.<br/>이메일 확인 후 하단의 입력란에 인증번호를 입력하세요.</div>',
      );
      t.push('<div style="text-align:center;">');
      t.push(
        '	<input type="text" id="certify" class="text" size="15" style="margin:30px 0;" placeholder="인증번호를 입력하세요." title="인증번호" data-valid="blank" />',
      );
      t.push(
        '	<span style="margin-left:15px">남은 인증시간 : </span><span id="modalTimer">05:00</span>',
      );
      t.push('</div>');

      return t.join('');
    },
    leftTime(t) {
      let minute, second;
      minute = parseInt(t / 60);
      second = t % 60;

      minute = minute < 10 ? `0${minute}` : minute;
      second = second < 10 ? `0${second}` : second;

      return `${minute}:${second}`;
    },
  };

  return {
    init: fn.init,
  };
})();
